
export const EDIT_GAME_VERSION_LABEL = "Версия игры"
